@if (userProcess(); as up) {
  {{ 'USER_PROCESS_STATUS.' + up.status | translate }}
}

@if (userProcessStatus()) {
  @if (iconOnly()) {
    <span
      class="status-code-pill status-code-pill--icon-only"
      [matTooltip]="'USER_PROCESS_STATUS.' + userProcessStatus() | translate"
      matTooltipClass="universalTooltip">
      {{ PRETTY_userProcessStatusCodes[userProcessStatus()] }}
    </span>
  } @else {
    <span class="status-code-pill">
      {{ PRETTY_userProcessStatusCodes[userProcessStatus()] }}
    </span>
    {{ 'USER_PROCESS_STATUS.' + userProcessStatus() | translate }}
  }
}
